import { lazy, Suspense } from 'react';
import { usePlatform } from '../display/components/usePlatform';
import { SceneHost } from '../display/scene/SceneHost';
import { tuningEnabled } from '../display/tuning/tuningGate';
import { PlaytestHost } from '../display/playtest/PlaytestHost';
import { isPlaytest } from '../systems/play/playtest';
import { matchPlayRoute, usePath } from './router';

// The sky tuning panel loads only on dev and staging with ?tune.
const TuningPanel = tuningEnabled() ? lazy(() => import('../display/tuning/TuningPanel')) : null;

export function App() {
  usePlatform();
  const path = usePath();
  // The level designer's playtest frame: the play screen alone, no scene.
  if (isPlaytest()) return <PlaytestHost />;
  return (
    <>
      <SceneHost playRoute={matchPlayRoute(path)} />
      {TuningPanel && (
        <Suspense fallback={null}>
          <TuningPanel />
        </Suspense>
      )}
    </>
  );
}
